import React from 'react';
import axios from 'axios';

import SelectField from '../shared/form-elements/select/field';

import reasons from './reasons';

export default function renderReason({ value }, { row, apply }) {
	return ['stopped', 'volumes-decreased'].includes(row.event) && (
		<div className='alerts-analytics-reason'>
			<SelectField
				name='reason'
				placeholder=''
				searchable={false}
				clearable={true}
				value={value && [reasons.find((r) => r.value === value)]}
				options={reasons}
				meta={{}}
				showLabel={false}
				onChange={async ([reason]) => {
					await axios({
						method: 'PUT',
						url: 'v2/traffic-alerts/reason',
						data: {
							message_id: row.message_id,
							chat_id: row.chat_id,
							reason: reason ? reason.value : null
						}
					});

					apply();
				}}
			/>
		</div>
	);
}



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/alerts-analytics/render-reason.js